export default __webpack_public_path__ + "static/media/thanks3.04609e7b.png";